module.exports = __webpack_public_path__ + "static/media/monday-in-Spanish.24752d78.png";